module.exports = __webpack_public_path__ + "static/img/about_menu_title.6d5acf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/about_article/about_menu_title.png
// module id = 634
// module chunks = 1